module.exports = __webpack_public_path__ + "img/0Q3A5798_L_WoodMatted_MockedUp.cc5cea98.jpg";